export default __webpack_public_path__ + "static/media/be-sure-stepsliide2.ec4c062c.png";